import React,{useState,useEffect} from  'react'
import { use } from 'react'
import DatePicker from 'react-datepicker'
import Helper from '../pages/Helper'
 function StartEndDate({onClick = null}){
    const [startDate,setStartDate] = useState(Date.now())
    const [endDate,setEndDate] = useState(Date.now())

    useEffect(()=>{
        if(onClick != null){
            onClick(Helper.GetDateYYYYMMDD(startDate),Helper.GetDateYYYYMMDD(endDate))
        }
         
    },[])
    return (
        <div style={{display:"flex",marginBottom:20}}>
                    <div style={{display:"flex",marginRight:30}}> 
                        <span style={{marginRight:10,paddingTop:8,fontSize:12}}>Start Date</span>
                        <DatePicker 
                            showIcon
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="dd-MM-yyyy"
                            className="form-control"
                            required
                         />
                    </div>
                    <div style={{display:"flex",marginRight:10}}>
                        <span style={{marginRight:10,paddingTop:8,fontSize:12}}>End Date</span>
                        <DatePicker 
                            showIcon
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            dateFormat="dd-MM-yyyy"
                            className="form-control"
                            required
                         />
                    </div>
                    <div>
                        <button className='btn btn-success ' onClick={(e) => onClick(Helper.GetDateYYYYMMDD(startDate),Helper.GetDateYYYYMMDD(endDate))}><span style={{fontSize:12}}>SEARCH</span></button>
                    </div>
        </div>
    )
}

export default StartEndDate